import React from 'react';
import { Store, Package, TrendingUp } from 'lucide-react';
import { howItWorksSteps } from '../data/mock';

const iconMap = { Store, Package, TrendingUp };

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            How It Works
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Up and running fast. Here&apos;s how it works.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-[40px] left-[16.67%] right-[16.67%] h-px bg-gradient-to-r from-indigo-200 via-indigo-300 to-indigo-200" />

          {howItWorksSteps.map((step) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={step.step} className="relative">
                {/* Number badge */}
                <div className="flex justify-center">
                  <div className="relative z-10 w-20 h-20 rounded-full bg-white border-2 border-indigo-100 flex items-center justify-center shadow-sm">
                    <div className="w-14 h-14 rounded-full brand-gradient flex items-center justify-center">
                      <span className="text-xl font-bold text-white">{step.step}</span>
                    </div>
                  </div>
                </div>
                <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-7 text-center hover:shadow-lg hover:border-indigo-200 transition-all duration-200">
                  <div className="w-14 h-14 mx-auto rounded-2xl bg-indigo-50 flex items-center justify-center mb-5">
                    <Icon className="w-7 h-7 text-indigo-600" strokeWidth={2} />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">{step.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
